<div class="container">
  <h3>{{'menu.CorrectionJob' | translate}}</h3>
  <div class="form-group">
    <div class="row">
      <div class="col-8">
        <strong>{{'correctionjob.CorrectionJobType' | translate}}</strong>&nbsp;&nbsp;
        <select [(ngModel)]="selectedReportId" name="reportid" (change)="toReportId()">
          <option *ngFor="let rid of reportids" [selected]="rid.booking_id==0" [ngValue]=rid>
            {{rid.descr}}
          </option>
        </select>
      </div>
    </div>
  </div>
  <br />
  <div class="form-group">
    <div class="row">
      <div class="col-1">
        <button class="btn pull-left" (click)="previousname()" [disabled]="(personIndex<=0)"><i class="fa fa-angle-left"></i></button>
      </div>
      <div class="col-6">
        <ng-select [items]="persons"
                   bindLabel="name"
                   (clear)="clearPerson()"
                   (close)="changePerson()"
                   (open)="getPerson()"
                   placeholder={{selectNameStr}}
                   [(ngModel)]="selectedPerson">
        </ng-select>
      </div>
      <div class="col-1">
        <button class="btn pull-right" (click)="nextname()" [disabled]="(!guser && !selectedPerson)"><i class="fa fa-angle-right"></i></button>
      </div>
      <div class="col-4">
        <button class="btn" (click)="organizationClick()"><strong>{{'common.Organization' | translate}}</strong></button>
      </div>
    </div>
  </div>
  <br />
  <div class="form-group">
    <div class="row align-items-center">
      <!-- Start Date Datepicker -->
      <div class="col-auto">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'stampreport.StartDate' | translate }}</mat-label>
          <input matInput
                 [matDatepicker]="startPicker"
                 [(ngModel)]="startDate"
                 (dateChange)="onDateChange1($event.value)">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <button mat-icon-button matSuffix *ngIf="startDate" (click)="clearStartDate()">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="col-auto">
        <button class="btn" (click)="execQuery()" [disabled]="!guser && !selectedPerson">
          <strong>{{ 'common.Run' | translate }}</strong>
        </button>
      </div>
      <!-- End Date Datepicker -->
      <div class="col-auto">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'stampreport.EndDate' | translate }}</mat-label>
          <input matInput
                 [matDatepicker]="endPicker"
                 [(ngModel)]="endDate"
                 (dateChange)="onDateChange2($event.value)">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
          <button mat-icon-button matSuffix *ngIf="endDate" (click)="clearEndDate()">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
  <div class="form-group">
    <ngx-datatable class="material"
                   [rows]="correctionjobs"
                   [headerHeight]="30"
                   [messages]="{emptyMessage: emptyMess, selectedMessage: false}"
                   [rowHeight]="'auto'">
      <ngx-datatable-column name="{{'employee.Surname' | translate}}" [width]="250">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          {{row.surname}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{'employee.Forename' | translate}}" [width]="150">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          {{row.forename}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{'common.Days' | translate}}" [width]="70">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          {{row.days}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{'common.FirstDate' | translate}}" [width]="150">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          {{row.start_date | date: 'dd.MM.yyyy' }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{'common.LastDate' | translate}}" [width]="150">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          {{row.end_date | date: 'dd.MM.yyyy' }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{'common.CorrectionInfo' | translate}}" [width]="400">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          {{row.info}}
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>

